module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("FOREWORD "), _c('i', [_vm._v("by Richard J. Mouw")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("INTRODUCTION")])]), _c('div', {
    staticClass: "SOM_pre1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("THE STATE "), _c('i', [_vm._v("of the")]), _vm._v(" EVANGELICAL MIND:"), _c('br'), _vm._v("TALES "), _c('i', [_vm._v("of")]), _vm._v("  PROSPERITY "), _c('i', [_vm._v("and")]), _vm._v(" PERIL"), _c('br'), _c('i', [_vm._v("by Todd C. Ream, Jerry Pattengale, and Christopher J. Devers")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_vm._v("1"), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("REFLECTIONS ON THE PAST")])])]), _c('div', {
    staticClass: "SOM_chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_vm._v("EVANGELICAL INTELLECTUAL LIFE:"), _c('br'), _vm._v("REFLECTIONS "), _c('i', [_vm._v("on the")]), _vm._v(" PAST "), _c('i', [_vm._v("by Mark A. Noll")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2"), _c('span', {
    staticClass: "tabulation1"
  }, [_vm._v("CHURCHES")])])]), _c('div', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE STATE "), _c('i', [_vm._v("of the")]), _vm._v(" EVANGELICAL CHURCH "), _c('i', [_vm._v("by Jo Anne Lyon")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3"), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("PARACHURCH ORGANIZATIONS")])])]), _c('div', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("UNIVERSITY MINISTRY "), _c('i', [_vm._v("and the")]), _vm._v(" EVANGELICAL MIND"), _c('br'), _c('i', [_vm._v("by David C. Mahan and C. Donald Smedley")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4"), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("COLLEGES AND UNIVERSITIES")])])]), _c('div', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JOHN HENRY NEWMAN'S "), _c('i', [_vm._v("THE IDEA OF A UNIVERSITY")]), _vm._v(" "), _c('i', [_vm._v("and")]), _vm._v(" CHRISTIAN COLLEGES "), _c('i', [_vm._v("in the")]), _vm._v(" TWENTY-FIRST CENTURY "), _c('i', [_vm._v("by Timothy Larsen")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5"), _c('span', {
    staticClass: "tabulation2"
  }, [_vm._v("SEMINARIES")])])]), _c('div', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CONTEMPLATIVE POSTURE "), _c('i', [_vm._v("and")]), _vm._v(" CHRIST-ADAPTED EYES: TEACHING "), _c('i', [_vm._v("and")]), _vm._v(" THINKING "), _c('i', [_vm._v("in")]), _vm._v(" CHRISTIAN SEMINARIES "), _c('i', [_vm._v("by Lauren F. Winner")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6"), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("PROSPECTS FOR THE FUTURE")])])]), _c('div', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE FUTURE IS CATHOLIC: THE NEXT SCANDAL "), _c('i', [_vm._v("for the")]), _vm._v(" EVANGELICAL MIND "), _c('i', [_vm._v("by James K. A. Smith")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen1"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CONCLUSION")])]), _c('div', {
    staticClass: "SOM_appen2"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE ONGOING CHALLENGE "), _c('i', [_vm._v("of the")]), _vm._v(" EVANGELICAL MIND "), _c('i', [_vm._v("by Mark Galli")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CONTRIBUTORS")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOTES")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PRAISE FOR "), _c('i', [_vm._v("THE STATE OF THE EVANGELICAL MIND")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHORS")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MORE TITLES FROM INTERVARSITY PRESS")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0